import {
  getAll,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
  getMyAll,
  getMyPage,
  changePicture,
  addCheck,
  modifyCheck,
  submit,
  cancel,
  sold,
  offShelves,
} from '@/api/vehicleinfoserv'

export default {
  state: {
    state_VehicleInfo_GetAllResult: null,
    state_VehicleInfo_GetPageResult: null,
    state_VehicleInfo_GetDetailResult: null,
    state_VehicleInfo_AddObjResult: null,
    state_VehicleInfo_ModifyObjResult: null,
    state_VehicleInfo_DeleteObjResult: null,
    state_VehicleInfo_GetMyAllResult: null,
    state_VehicleInfo_GetMyPageResult: null,
    state_VehicleInfo_ChangePictureResult: null,
    state_VehicleInfo_AddCheckResult: null,
    state_VehicleInfo_ModifyCheckResult: null,
    state_VehicleInfo_SubmitResult: null,
    state_VehicleInfo_CancelResult: null,
    state_VehicleInfo_SoldResult: null,
    state_VehicleInfo_OffShelvesResult: null,
  },
  mutations: {
    SET_VEHICLEINFO_GETALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetAllResult = rst;
    },
    SET_VEHICLEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetPageResult = rst;
    },
    SET_VEHICLEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetDetailResult = rst;
    },
    SET_VEHICLEINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfo_AddObjResult = rst;
    },
    SET_VEHICLEINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfo_ModifyObjResult = rst;
    },
    SET_VEHICLEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_VehicleInfo_DeleteObjResult = rst;
    },
    SET_VEHICLEINFO_GETMYALL_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetMyAllResult = rst;
    },
    SET_VEHICLEINFO_GETMYPAGE_RESULT: (state, rst) => {
      state.state_VehicleInfo_GetMyPageResult = rst;
    },
    SET_VEHICLEINFO_CHANGEPICTURE_RESULT: (state, rst) => {
      state.state_VehicleInfo_ChangePictureResult = rst;
    },
    SET_VEHICLEINFO_ADDCHECK_RESULT: (state, rst) => {
      state.state_VehicleInfo_AddCheckResult = rst;
    },
    SET_VEHICLEINFO_MODIFYCHECK_RESULT: (state, rst) => {
      state.state_VehicleInfo_ModifyCheckResult = rst;
    },
    SET_VEHICLEINFO_SUBMIT_RESULT: (state, rst) => {
      state.state_VehicleInfo_SubmitResult = rst;
    },
    SET_VEHICLEINFO_CANCEL_RESULT: (state, rst) => {
      state.state_VehicleInfo_CancelResult = rst;
    },
    SET_VEHICLEINFO_SOLD_RESULT: (state, rst) => {
      state.state_VehicleInfo_SoldResult = rst;
    },
    SET_VEHICLEINFO_OFFSHELVES_RESULT: (state, rst) => {
      state.state_VehicleInfo_OffShelvesResult = rst;
    },
  },
  actions: {
    VehicleInfoServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_GetMyAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETMYALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_GETMYALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_ChangePicture({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changePicture(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_CHANGEPICTURE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_CHANGEPICTURE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_AddCheck({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addCheck(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_ADDCHECK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_ADDCHECK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_ModifyCheck({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyCheck(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_MODIFYCHECK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_MODIFYCHECK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_Submit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        submit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_SUBMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_SUBMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_Cancel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_CANCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_CANCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_Sold({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        sold(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_SOLD_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_SOLD_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    VehicleInfoServ_OffShelves({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        offShelves(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_VEHICLEINFO_OFFSHELVES_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_VEHICLEINFO_OFFSHELVES_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_VehicleInfo_GetAllResult: state => {
      return state.state_VehicleInfo_GetAllResult;
    },
    get_VehicleInfo_GetPageResult: state => {
      return state.state_VehicleInfo_GetPageResult;
    },
    get_VehicleInfo_GetDetailResult: state => {
      return state.state_VehicleInfo_GetDetailResult;
    },
    get_VehicleInfo_AddObjResult: state => {
      return state.state_VehicleInfo_AddObjResult;
    },
    get_VehicleInfo_ModifyObjResult: state => {
      return state.state_VehicleInfo_ModifyObjResult;
    },
    get_VehicleInfo_DeleteObjResult: state => {
      return state.state_VehicleInfo_DeleteObjResult;
    },
    get_VehicleInfo_GetMyAllResult: state => {
      return state.state_VehicleInfo_GetMyAllResult;
    },
    get_VehicleInfo_GetMyPageResult: state => {
      return state.state_VehicleInfo_GetMyPageResult;
    },
    get_VehicleInfo_ChangePictureResult: state => {
      return state.state_VehicleInfo_ChangePictureResult;
    },
    get_VehicleInfo_AddCheckResult: state => {
      return state.state_VehicleInfo_AddCheckResult;
    },
    get_VehicleInfo_ModifyCheckResult: state => {
      return state.state_VehicleInfo_ModifyCheckResult;
    },
    get_VehicleInfo_SubmitResult: state => {
      return state.state_VehicleInfo_SubmitResult;
    },
    get_VehicleInfo_CancelResult: state => {
      return state.state_VehicleInfo_CancelResult;
    },
    get_VehicleInfo_SoldResult: state => {
      return state.state_VehicleInfo_SoldResult;
    },
    get_VehicleInfo_OffShelvesResult: state => {
      return state.state_VehicleInfo_OffShelvesResult;
    },
  }
}